var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview_c_w"},[_c('el-dialog',{attrs:{"visible":_vm.previewImgDialog,"append-to-body":""},on:{"close":_vm.onClosePreview}},[_c('img',{attrs:{"width":"100%","src":_vm.previewImgUrl,"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }